module.exports = __webpack_public_path__ + "static/media/callRequest.f9179021.svg";